import { Component } from '@angular/core';

@Component({
	selector: 'lomas-public-toolbar',
	templateUrl: './public-toolbar.component.html',
	styleUrls: ['./public-toolbar.component.scss']
})
export class PublicToolbarComponent {}